var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 0.457031H1.77187C0.792187 0.457031 0 1.23047 0 2.18672V22.7227C0 23.6789 0.792187 24.457 1.77187 24.457H22.2234C23.2031 24.457 24 23.6789 24 22.7273V2.18672C24 1.23047 23.2031 0.457031 22.2234 0.457031ZM7.12031 20.9086H3.55781V9.45234H7.12031V20.9086ZM5.33906 7.89141C4.19531 7.89141 3.27188 6.96797 3.27188 5.82891C3.27188 4.68984 4.19531 3.76641 5.33906 3.76641C6.47813 3.76641 7.40156 4.68984 7.40156 5.82891C7.40156 6.96328 6.47813 7.89141 5.33906 7.89141ZM20.4516 20.9086H16.8937V15.3398C16.8937 14.0133 16.8703 12.3023 15.0422 12.3023C13.1906 12.3023 12.9094 13.7508 12.9094 15.2461V20.9086H9.35625V9.45234H12.7687V11.018H12.8156C13.2891 10.118 14.4516 9.16641 16.1813 9.16641C19.7859 9.16641 20.4516 11.5383 20.4516 14.6227V20.9086Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ef75f1f2e4daa247e432e36602c08fa2.svg";
export { ForwardRef as ReactComponent };